/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_SwapInputs */

const id_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tukar`)
};

const ms_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tukar`)
};

const da_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byt`)
};

const de_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tauschen`)
};

const en_us2_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swap`)
};

const es_es2_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intercambiar`)
};

const es_mx2_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intercambiar`)
};

const fil_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagpalitin`)
};

const fr_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inverser`)
};

const it_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scambia`)
};

const hu_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Felcserélés`)
};

const nl_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wisselen`)
};

const no_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bytt`)
};

const pl_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamień`)
};

const pt_br2_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trocar`)
};

const pt_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trocar`)
};

const ro_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schimbă`)
};

const fi_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaihda`)
};

const sv_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byt`)
};

const vi_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoán đổi`)
};

const tr_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değiştir`)
};

const cs_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prohodit`)
};

const bg_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Размени`)
};

const ru_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поменять местами`)
};

const uk_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поміняти місцями`)
};

const ar_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تبديل`)
};

const hi_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अदला-बदली`)
};

const th_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สลับ`)
};

const ja_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入れ替え`)
};

const zh_cn2_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`交换`)
};

const zh_hant1_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`交換`)
};

const ko_builds_comparison_swap = /** @type {(inputs: Builds_Comparison_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`교체`)
};

/**
* | output |
* | --- |
* | "Swap" |
*
* @param {Builds_Comparison_SwapInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_swap = /** @type {((inputs?: Builds_Comparison_SwapInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_SwapInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_swap(inputs)
	if (locale === "ms") return ms_builds_comparison_swap(inputs)
	if (locale === "da") return da_builds_comparison_swap(inputs)
	if (locale === "de") return de_builds_comparison_swap(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_swap(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_swap(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_swap(inputs)
	if (locale === "fil") return fil_builds_comparison_swap(inputs)
	if (locale === "fr") return fr_builds_comparison_swap(inputs)
	if (locale === "it") return it_builds_comparison_swap(inputs)
	if (locale === "hu") return hu_builds_comparison_swap(inputs)
	if (locale === "nl") return nl_builds_comparison_swap(inputs)
	if (locale === "no") return no_builds_comparison_swap(inputs)
	if (locale === "pl") return pl_builds_comparison_swap(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_swap(inputs)
	if (locale === "pt") return pt_builds_comparison_swap(inputs)
	if (locale === "ro") return ro_builds_comparison_swap(inputs)
	if (locale === "fi") return fi_builds_comparison_swap(inputs)
	if (locale === "sv") return sv_builds_comparison_swap(inputs)
	if (locale === "vi") return vi_builds_comparison_swap(inputs)
	if (locale === "tr") return tr_builds_comparison_swap(inputs)
	if (locale === "cs") return cs_builds_comparison_swap(inputs)
	if (locale === "bg") return bg_builds_comparison_swap(inputs)
	if (locale === "ru") return ru_builds_comparison_swap(inputs)
	if (locale === "uk") return uk_builds_comparison_swap(inputs)
	if (locale === "ar") return ar_builds_comparison_swap(inputs)
	if (locale === "hi") return hi_builds_comparison_swap(inputs)
	if (locale === "th") return th_builds_comparison_swap(inputs)
	if (locale === "ja") return ja_builds_comparison_swap(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_swap(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_swap(inputs)
	return ko_builds_comparison_swap(inputs)
});
export { builds_comparison_swap as "builds.comparison.swap" }